// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import HomePage from './pages/HomePage';
import JimmyPage from './pages/Jimmy';
import CalendarioPage from './pages/CalendarioPage';
import JurisprudenciaPage from './pages/Jurisprudencia';
import PerfilPage from './pages/Perfil';
import Calculadora from './pages/Calculadora';
import Modelos from './pages/Modelos';
import AreaAdvogado from './pages/AreaAdvogado';
import AreaCliente from './pages/AreaCliente';
import Login from './pages/Login';
import Cadastro from './pages/Cadastro';
import PrivateRoute from './components/PrivateRoute';
import { FormProvider } from './context/FormContext';


const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
};

// Componente separado para facilitar o uso do contexto
const AppContent = () => {
  const { currentUser } = useAuth();

  return (
    <div className="navbar-container">
      <Router basename={process.env.PUBLIC_URL || undefined}>
        {/* Renderizar Navbar apenas se o usuário estiver logado */}
        {currentUser && <Navbar />}

        <Routes>
          {/* Rotas públicas */}
          <Route path="/login" element={<Login />} />


          <Route path="/cadastro" element={<Cadastro />} />

          {/* Rotas protegidas */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <HomePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/jimmy"
            element={
              <PrivateRoute>
                <JimmyPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/calendario"
            element={
              <PrivateRoute>
                <FormProvider>
                  <CalendarioPage />
                </FormProvider>
              </PrivateRoute>
            }
          />
          <Route
            path="/jurisprudencia"
            element={
              <PrivateRoute>
                <JurisprudenciaPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/calculadora"
            element={
              <PrivateRoute>
                <Calculadora />
              </PrivateRoute>
            }
          />
          <Route
            path="/modelos"
            element={
              <PrivateRoute>
                <Modelos />
              </PrivateRoute>
            }
          />
          <Route
            path="/areadocliente"
            element={
              <PrivateRoute>
                <FormProvider>
                  <AreaAdvogado />
                </FormProvider>
              </PrivateRoute>
            }
          />
          <Route
            path="/cliente/:token"
            element={
              <FormProvider>
                <AreaCliente />
              </FormProvider>
            }
          />
          <Route
            path="/perfil"
            element={
              <PrivateRoute>
                <PerfilPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
